













import { Component, Prop } from 'vue-property-decorator';
import { colors } from 'vuetify/lib';
import IdeaIcon from '@/components/Helper/Icon/Svg/IdeaIcon.vue';
import IssueItemBaseMixin from './IssueItem/issue-item-base.mixin';

@Component<IssueStatusBtn>({
  components: { IdeaIcon },
})
export default class IssueStatusBtn extends IssueItemBaseMixin {
  @Prop({ type: Boolean, default: false })
  mini: boolean;

  get style() {
    const style: any = {
      border: `thin solid ${this.color.border}!important`,
    };
    if (this.mini) {
      style.height = '18px';
    }
    return style;
  }

  get color(): { bg: string; border: string } {
    if (this.issue.isResolved) {
      return {
        bg: colors.green.accent4,
        border: colors.green.base,
      };
    }
    if (this.issue.isSupported) {
      return {
        bg: colors.blue.lighten2,
        border: colors.blue.base,
      };
    }
    return {
      bg: colors.deepOrange.base,
      border: colors.deepOrange.darken4,
    };
  }

  get status() {
    if (this.issue.isResolved) {
      return this.$t('home.issueItem.header.btnResolved');
    }
    if (this.issue.isSupported) {
      return this.$t('home.issueItem.header.supporting');
    }
    return this.$t('home.issueItem.header.btnUnresolved');
  }

  get btnClasses(): string {
    if (this.mini) {
      return 'rounded-xl border--thin white--text px-2 py-0 font-weight-black';
    }
    return 'rounded-lg border--thin white--text px-2 font-weight-bold';
  }
}
